theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      /* Add a Button For SubMenu Toggle */
      offcanvasMenu.forEach((item) => {
        item
        .querySelectorAll(".offcanvas__sub_menu")
        .forEach(function (ul) {
          const subMenuToggle = document.createElement("button");
          subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
          subMenuToggle.setAttribute("aria-label", "menu collapse");
          ul.parentNode.appendChild(subMenuToggle);
        });


      });
      
      /* Barrierefreiheit: Solange das Menue zu ist, ist es nur unsichtbar
         (opacity 0) - ohne inert landete die Tastatur in ~23 unsichtbaren
         Links. inert folgt der Klasse "open", egal wer sie setzt oder
         entfernt (Burger, Schliessen, Klick daneben, Resize). */
      if (offcanvasHeader) {
        let wasOpen = false;
        const syncInert = () => {
          const open = offcanvasHeader.classList.contains("open");
          if (open) offcanvasHeader.removeAttribute("inert");
          else offcanvasHeader.setAttribute("inert", "");
          /* Offen: Seite dahinter nicht per Tab erreichbar (vorher scrollte Tab
             die Seite hinter dem Menue), Fokus ins Menue; zu: zurueck zum Burger. */
          document.querySelectorAll("#MainContent, .shopify-section-group-footer-group").forEach((el) => {
            if (open) el.setAttribute("inert", "");
            else el.removeAttribute("inert");
          });
          if (open && !wasOpen) {
            /* erstes SICHTBARES Ziel (das Logo im Panel ist 0 px gross und nimmt keinen Fokus) */
            setTimeout(() => {
              const first = Array.from(offcanvasHeader.querySelectorAll(".offcanvas__menu a[href], .offcanvas__menu button:not([disabled])"))
                .find((el) => el.getClientRects().length && el.offsetWidth > 0 && getComputedStyle(el).visibility !== "hidden");
              if (first) first.focus({ preventScroll: true });
            }, 120);
          } else if (!open && wasOpen && offcanvasOpen &&
            (offcanvasHeader.contains(document.activeElement) || document.activeElement === document.body)) {
            offcanvasOpen.focus({ preventScroll: true });
          }
          wasOpen = open;
        };
        syncInert();
        new MutationObserver(syncInert).observe(offcanvasHeader, { attributes: true, attributeFilter: ["class"] });

        /* Zurueck/Vor aus dem Browser-Cache: Menue, Dialoge und Scroll-Sperre
           kamen sonst offen zurueck. */
        window.addEventListener("pageshow", function (e) {
          if (!e.persisted) return;
          offcanvasHeader.classList.remove("open");
          body.style.overflowY = null;
          document.querySelectorAll("dialog[open]").forEach(function (d) {
            try { d.close(); } catch (err) {}
          });
        });
      }

      /* Open/Close Menu On Click Toggle Button
         (toggle statt add: unter 750px ist der Burger selbst das X) */
      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        const isOpen = offcanvasHeader.classList.toggle("open");
        body.style.overflowY = isOpen ? "hidden" : null;
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.remove("open");
        body.style.overflowY = null;
      });
      
      
      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        offcanvasMenuitem
        .querySelectorAll(".offcanvas__sub_menu_toggle")
        .forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const parent = this.parentElement;
            if (parent.classList.contains("active")) {
              this.classList.remove("active");
              parent.classList.remove("active");
              parent
              .querySelectorAll(".offcanvas__sub_menu")
              .forEach(function (subMenu) {
                subMenu.parentElement.classList.remove("active");
                subMenu.nextElementSibling.classList.remove("active");
                slideUp(subMenu);
              });
            } else {
              this.classList.add("active");
              parent.classList.add("active");
              slideDown(this.previousElementSibling);
              getSiblings(parent).forEach(function (item) {
                item.classList.remove("active");
                item
                .querySelectorAll(".offcanvas__sub_menu")
                .forEach(function (subMenu) {
                  subMenu.parentElement.classList.remove("active");
                  subMenu.nextElementSibling.classList.remove("active");
                  slideUp(subMenu);
                });
              });
            }
          });
        });                   
      })
      

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            offcanvasHeader.classList.remove("open");
            body.style.overflowY = null;
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          offcanvasHeader.classList.remove("open");
          body.style.overflowY = null;
        }
      });
    };
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();
